import { ClientBase } from "./base.js";
import { RepairClient } from "./repair.js";
/** Staff tasks (/tasks) and the staff announcement board (/announcements). */
export class TasksClient extends RepairClient {
    taskBase(slug, id) {
        const base = `${this.siteBase(slug)}/tasks`;
        return id === undefined ? base : `${base}/${encodeURIComponent(id)}`;
    }
    async listStaffTasks(slug, params = {}) {
        const res = await this.request("GET", `${this.taskBase(slug)}${ClientBase.query({ board: params.board, updatedSince: params.updatedSince })}`, undefined, true);
        return res.tasks;
    }
    /** Supervisors (employees:manage) only. */
    async createStaffTask(slug, input) {
        return this.request("POST", this.taskBase(slug), input, true);
    }
    async getStaffTask(slug, id) {
        return this.request("GET", this.taskBase(slug, id), undefined, true);
    }
    /** `updatedAt` required; 409 `stale_update` when changed. */
    async patchStaffTask(slug, id, input) {
        return this.request("PATCH", this.taskBase(slug, id), input, true);
    }
    async deleteStaffTask(slug, id) {
        await this.request("DELETE", this.taskBase(slug, id), undefined, true);
    }
    async joinTaskAsMe(slug, id) {
        return this.request("POST", `${this.taskBase(slug, id)}/assignees/me`, undefined, true);
    }
    async leaveTaskAsMe(slug, id) {
        return this.request("DELETE", `${this.taskBase(slug, id)}/assignees/me`, undefined, true);
    }
    async addTaskNote(slug, id, body) {
        return this.request("POST", `${this.taskBase(slug, id)}/notes`, { body }, true);
    }
    /** Only the note's author may edit. */
    async patchTaskNote(slug, id, noteId, body) {
        return this.request("PATCH", `${this.taskBase(slug, id)}/notes/${encodeURIComponent(noteId)}`, { body }, true);
    }
    async deleteTaskNote(slug, id, noteId) {
        return this.request("DELETE", `${this.taskBase(slug, id)}/notes/${encodeURIComponent(noteId)}`, undefined, true);
    }
    // Announcements (staff audience only)
    /** `includeExpired` is honoured only for supervisors. */
    async listAnnouncements(slug, params = {}) {
        const res = await this.request("GET", `${this.siteBase(slug)}/announcements${ClientBase.query({ includeExpired: params.includeExpired ? "true" : undefined })}`, undefined, true);
        return res.announcements;
    }
    /** employees:manage. */
    async createAnnouncement(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/announcements`, input, true);
    }
    /** employees:manage. 204. */
    async deleteAnnouncement(slug, id) {
        await this.request("DELETE", `${this.siteBase(slug)}/announcements/${encodeURIComponent(id)}`, undefined, true);
    }
}
//# sourceMappingURL=tasks.js.map